<template>
  <v-card
    flat
    class="pa-3 mt-1"
  >
    <v-card-title class="d-flex align-center justify-center py-0">
      <div
        class="d-flex align-center"
      >
        <v-img
          :src="require(`@/assets/images/logos/logo.png`)"
          max-width="300px"
          alt="logo"
          contain
          class="me-0 "
        ></v-img>
      </div>
    </v-card-title>
    <v-form class="multi-col-validation">
      <v-card-text class="pt-1">
        <p class="text-h6 text-center">Add Employee Salary</p>
        <v-row>
          <v-col cols="10" class="py-0 my-1">
            <v-text-field
              v-model="userName"
              ref="userName"
              outlined dense
              label="Search employee..."
            ></v-text-field>
          </v-col>
          <v-col cols="2" class="py-0 my-1">
            <v-btn
              color="success"
              class="me-3"
              fab small
              @click="getEmployee()"
            >
              <font-awesome-icon icon="fa-solid fa-magnifying-glass" />
            </v-btn>
          </v-col>
          <v-col
            cols="12"
            class="py-0 my-1"
          >
            <v-select
              v-model="selectedClient"
              ref="selectedClient"
              :items="clients"
              item-text="username"
              item-value="id"
              outlined dense
              label="Select Employee"
            ></v-select>
          </v-col>

          <v-col cols="12" class="py-0 my-1">
            <v-textarea
              outlined
              v-model="description"
              ref="description"
              name="input-7-4"
              label="Enter Salary Description"
            ></v-textarea>
          </v-col>

          <v-col
            cols="12"
            class="py-0 my-1"
          >
            <v-text-field
              v-model="salary"
              ref="salary"
              outlined
              dense
              label="Enter Salary Amount"
            ></v-text-field>
          </v-col>

          <v-col cols="12" class="py-0 my-1">
            <v-file-input
              show-size
              v-model="employee_file"
              ref="employee_file"
              truncate-length="18"
              style="cursor: pointer"
              label="Choose Employee Contract"
            ></v-file-input>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text class="text-end">
        <spinner v-if="loading" class="text-end"></spinner>
        <v-btn 
          v-else
          color="primary"
          class="me-3 mt-3"
          @click="addEmployeeSalary()"
        >
          Add Salary
        </v-btn>
      </v-card-text>
    </v-form>
  </v-card>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import { mdiKeyOutline, mdiLockOpenOutline, mdiEyeOffOutline, mdiEyeOutline } from '@mdi/js'
import axios from 'axios'
import Spinner from "@/components/Spinner.vue";

export default {
  components: {
    Spinner,
  },

  data() {

    return {
      loading: false,
      userName: '',
      clients: [],
      selectedClient: "",

      description: "",
      employee_file: [],
      salary: "",

      mdiKeyOutline,
      mdiLockOpenOutline,
      mdiEyeOffOutline,
      mdiEyeOutline,
    }
  },
  
  mounted(){
      // executes these after the page has been mounted
      document.title = "Manager: Savings | Add Investments"
  },

  methods:{
    getEmployee(){
      axios
        .get('/api/v1/manager/get/clients/'+this.userName+'/')
        .then(response => {
          this.clients = response.data  // get the data and fill into campaigns
          this.selectedClient = response.data[0]["id"]  // get the data and fill into campaigns
        })
        .catch(error => {
          if (error.response){
            this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText)
            this.$store.commit('setSnackBarColor', "red darken-4")
            this.$store.commit('activateSnackBar', true)
          }else{
            this.$store.commit('setSnackBarMessage', "An error occured, please check your internet connection and try again later.")
            this.$store.commit('setSnackBarColor', "red darken-4")
            this.$store.commit('activateSnackBar', true)
          }
        })
    },

    async addEmployeeSalary(){
      // console.log(this.resourceFile)
      if(this.description === ""){
          this.$store.commit('setSnackBarMessage', "Please input the Investment description")
          this.$store.commit('setSnackBarColor', "red darken-4")
          this.$store.commit('activateSnackBar', true)
          this.$refs.description.focus()  // this causes a an auto fucos to the element
      }
      else if(this.salary === ""){
          this.$store.commit('setSnackBarMessage', "Please input the invested salary")
          this.$store.commit('setSnackBarColor', "red darken-4")
          this.$store.commit('activateSnackBar', true)
          this.$refs.salary.focus()  // this causes a an auto fucos to the element
      }
      else if(this.selectedClient === ""){
          this.$store.commit('setSnackBarMessage', "Please select the partner")
          this.$store.commit('setSnackBarColor', "red darken-4")
          this.$store.commit('activateSnackBar', true)
          this.$refs.selectedClient.focus()  // this causes a an auto fucos to the element
      }
      else if(!this.employee_file){
          this.$store.commit('setSnackBarMessage', "Please upload the employee file")
          this.$store.commit('setSnackBarColor', "red darken-4")
          this.$store.commit('activateSnackBar', true)
          this.$refs.employee_file.focus()  // this causes a an auto fucos to the element
      }
      else {
          this.loading = true

          let formData = new FormData()
          formData.append('employee', this.selectedClient)
          formData.append('description', this.description)
          formData.append('salary', this.salary)
          formData.append('employee_file', this.employee_file)

          await axios
              .post('/api/v1/manager/add/employee_salary/', formData, {headers: {'Content-Type': 'multipart/form-data'}})
              .then(response => {
                  this.$store.commit('setSnackBarMessage', response.data[0].text)
                  this.$store.commit('setSnackBarColor', response.data[0].color)
                  this.$store.commit('activateSnackBar', true)
                  if(response.data[0].id !== 0){
                      let router = this.$router
                      setTimeout(function(){
                          router.push({ name: 'savings.salaries'})
                      }, 4000)
                  }
              })
              .catch(error => {
                  if (error.response){
                      this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText)
                      this.$store.commit('setSnackBarColor', "red darken-4")
                      this.$store.commit('activateSnackBar', true)
                  }else{
                      this.$store.commit('setSnackBarMessage', "An error occured, please check your internet connection and try again later.")
                      this.$store.commit('setSnackBarColor', "red darken-4")
                      this.$store.commit('activateSnackBar', true)
                  }
              })

          this.loading = false
      }
    },
  },
}
</script>
